import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ChevronTop = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="8"
    height="8"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M940.36 782.811c24.841-1.903 46.63-13.589 61.766-31.167l.099-.119c13.533-15.703 21.775-36.298 21.775-58.819 0-27.432-12.228-52.01-31.534-68.577l-.121-.102-421.538-361.319c-15.7-13.527-36.293-21.764-58.807-21.764s-43.107 8.237-58.926 21.863l.119-.099L31.655 624.027C12.231 640.696 0 665.271 0 692.706c0 22.52 8.243 43.115 21.874 58.937l-.099-.119c16.663 19.345 41.19 31.519 68.563 31.519 22.574 0 43.214-8.282 59.05-21.97l-.116.096 362.73-310.743 362.73 310.743c15.723 13.603 36.369 21.888 58.951 21.888a92.2 92.2 0 0 0 6.984-.265l-.305.02z"
      fill={color}
    />
  </svg>
));

export default ChevronTop;
